import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fd36db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProfileHeader" }
const _hoisted_2 = { class: "ProfileHeader__Center" }
const _hoisted_3 = { class: "ProfileHeader__Right" }
const _hoisted_4 = { class: "ProfileHeader__Socials" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 11 20" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-facebook" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-instagram" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 16 16" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-linkedin" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 3 }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-tiktok" })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_ctx.profile)
      ? (_openBlock(), _createBlock(_component_LazyPicture, {
          key: 0,
          image: _ctx.profile.avatar,
          alt: _ctx.profile?.firstName,
          class: "ProfileHeader__Left picture picture--fullscreen"
        }, null, 8, ["image", "alt"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.profile?.firstName) + " " + _toDisplayString(_ctx.profile?.lastName), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.profile?.surname), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.isUser)
        ? (_openBlock(), _createBlock(_component_ButtonHover, {
            key: 0,
            class: "button button--small button--white button--border",
            to: "/my-profile/edit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('profile.edit')), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ButtonHover, {
            key: 1,
            class: "button button--small button--black",
            href: `mailto:${_ctx.profile?.email}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('profile.contact')), 1)
            ]),
            _: 1
          }, 8, ["href"])),
      _createElementVNode("ul", _hoisted_4, [
        (_ctx.profile?.socials?.facebook)
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createElementVNode("a", {
                href: _ctx.profile?.socials?.facebook,
                target: "_blank",
                class: "ProfileHeader__Socials__Link ProfileHeader__Socials__Link--Facebook"
              }, _hoisted_8, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        (_ctx.profile?.socials?.instagram)
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("a", {
                href: _ctx.profile?.socials?.instagram,
                target: "_blank",
                class: "ProfileHeader__Socials__Link ProfileHeader__Socials__Link--Instagram"
              }, _hoisted_12, 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (_ctx.profile?.socials?.linkedin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createElementVNode("a", {
                href: _ctx.profile?.socials?.linkedin,
                target: "_blank",
                class: "ProfileHeader__Socials__Link ProfileHeader__Socials__Link--LinkedIn"
              }, _hoisted_16, 8, _hoisted_14)
            ]))
          : _createCommentVNode("", true),
        (_ctx.profile?.socials?.tiktok)
          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
              _createElementVNode("a", {
                href: _ctx.profile?.socials?.tiktok,
                target: "_blank",
                class: "ProfileHeader__Socials__Link ProfileHeader__Socials__Link--Tiktok"
              }, _hoisted_20, 8, _hoisted_18)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_21
  ]))
}